/// <reference path="../ResultListController.ts" />
/// <reference path="../../HTML/Page/ResultItem.ts" />
/// <reference path="../../HTML/Container/List/List.ts" />
namespace HA.Core.Controller.Page {
    import List = HA.Core.HTML.List;
    import ResultItem = HA.Core.HTML.ResultItem;
    import CFlexContainer = HA.Core.HTML.CFlexContainer;

    export class SearchableController extends ResultListController {
        /**
         * @param data
         */
        protected initialize(data: Map<any, any>) {
            super.initialize(data);
            const c = new CFlexContainer();
            const me = this;
            const l = new List({entryClass: this.getResultItem()});
            if (data.has("pfunc") && data.get("pfunc").itemClick) {
                l.setItemClick(data.get("pfunc").itemClick);
            }
            if (this.showSearchBox()) {
                const sbox = new SearchBoxController({
                    kup: (txt) => {
                        me.search(txt);
                    },
                });
                c.appendChild(sbox);
            }

            c.appendChild(l);
            this.addToData("listTag", l);

            let parentCont = this.get("parentTag");
            if (parentCont) {
                const list = parentCont.fetchByAttribute('rl');
                if (list.length > 0) {
                    parentCont = list[0];
                }
            }
            parentCont.appendChild(c);
            this.addToData("tag", c);

            this.addItems(this.get("d"));
            const is = this.get("is");
            if (is) {
                this.addToData("is", toMap(is));
                this.addToData("sd", toMap(is));
                getWebPageService().subscribeToAppInfo(() => {
                    if (me.isActive()) {
                        me.initWatch4Reload();
                    }
                });
                this.initWatch4Reload();
            }

        }

        protected getResultItem() {
            return ResultItem;
        }

        protected showSearchBox(): boolean {
            return this.get("showSearchBox") !== "no";
        }

        protected search(txt: string): void {
            const is: Map<any, any> = this.get("sd") || new Map();
            is.set("q", txt);
            is.set("los", 0);
            this.addToData("is", toMap(is));
            this.getListTag().clear();
            this.infiniteReload();
        }

        protected initWatch4Reload() {
            if (!this.isActive()) {
                return;
            }
            this.unlock();
            const me = this;
            this.watch4Reload(() => {
                me.infiniteReload();
            });
        }

        protected unlock(): void {
            this.addToData("lock", false);
        }

        protected lock(): void {
            this.addToData("lock", true);
        }

        protected isLock(): boolean {
            return this.get("lock") === true;
        }

        protected addItems(items: Map<any, any> | []) {
            if (this.has("m")) {
                const tag = this.getListTag();
                tag.setModel(this.get("m"));
                if (items) {
                    items.forEach((i: any) => {
                        tag.addByModel(toMap(i));
                    });
                }
            }
        }

        protected getListTag(): List {
            return this.get("listTag");
        }

        protected getAppId(): string | undefined {
            return this.get("appId");
        }

        protected isActive(): boolean {
            return this.has("pfunc") || getWebPageService().isActive(this.getAppId());
        }

        private infiniteReload(): void {
            const is = this.get("is");
            if (!is || is.size < 1 || is.get("los") < 0) {
                this.removeWatch4Reload();
                return;
            }
            if (this.isLock()) {
                return;
            }
            this.lock();

            const me = this;

            if (!me.isActive()) {
                me.lock();
                me.removeWatch4Reload();
                return;
            }
            getDataRepository().fetchData(is).then((response: Map<any, any>) => {
                const success = response.get("success");

                if (success) {
                    const data = toMap(response.get("d"));
                    if (data) {
                        me.addItems(data.get("l"));
                        //me.initAnchors();
                    }
                    me.addToData("is", toMap(data.get("is")));

                    if (!me.isActive()) {
                        me.lock();
                        me.removeWatch4Reload();
                        return;
                    }
                } else {
                    if (response.has("t")) {
                        getAppService().processAction(response);
                    } else if (response.has("msg")) {
                        log(response.get("msg"));
                    }
                }
                me.unlock();
            }).catch((reason: any) => {
                log2(["err::searchCtrl", reason, is]);
                me.unlock();
            });
        }

    }
}
